import * as numeral from 'numeral';

import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { DataTableConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-geofence-apps',
	styleUrls: ['./geofence-apps.component.css'],
	templateUrl: './geofence-apps.component.html'
})
export class GeofenceAppsComponent implements OnInit, OnDestroy {
	@ViewChild('appNameTemplate') appNameTemplate: TemplateRef<any>;
	@Input() downloadconfig: string;
	@Input() datatableconfig;
	@Input() nodatamessage;

	geofenceAppData: any[];
	public downloadConfiguration: DownloadConfig;
	public sectiontitle: string;
	public key: string;
	columns = [];
	public tableConfig: DataTableConfig = {} as DataTableConfig;
	showLoad = true;
	public hasData: boolean;
	reorderable = false;
	public currentPage = 0;

	public reloadSubscription;
	public widgetDataSubscription;

	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big'
	};

	constructor(protected analyticsService: AnalyticsService) {
		this.geofenceAppData = [];
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.tableConfig = JSON.parse(decodeURI(this.datatableconfig));
		this.columns = [
			{
				cellClass: 'domain',
				cellTemplate: this.appNameTemplate,
				comparator: this.appNameCounterComparator.bind(this),
				headerClass: 'domainHeader',
				name:
					this.tableConfig && this.tableConfig.columns && this.tableConfig.columns[0].columnName
						? this.tableConfig.columns[0].columnName
						: 'App Name',
				prop: this.tableConfig && this.tableConfig.columns && this.tableConfig.columns[0].columnKey
						? this.tableConfig.columns[0].columnKey
						: 'formattedAppName',
				resizeable: false
			},
			{
				cellClass: 'impressions',
				comparator: this.impressionsComparator.bind(this),
				headerClass: 'impressionsHeader',
				name: 'Impressions',
				prop: 'formattedImpressions',
				resizeable: false
			},
			{
				cellClass: 'clicks',
				comparator: this.clicksComparator.bind(this),
				headerClass: 'clicksHeader',
				name: 'Clicks',
				prop: 'formattedClicks',
				resizeable: false
			},
			{
				cellClass: 'clickRate',
				comparator: this.clickRateComparator.bind(this),
				headerClass: 'clickRateHeader',
				name: 'Click Rate',
				prop: 'formattedClickRate',
				resizeable: false
			}
		];
		if (!this.nodatamessage || this.nodatamessage === 'undefined') {
			this.nodatamessage = 'No data to display';
		}
		this.requestData();
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.hasData = true;
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			this.showLoad = false;
			this.geofenceAppData = [];
			if (res.success) {
				this.hasData = true;
				this.processResponseData(res.data);
			} else {
				this.hasData = false;
				this.geofenceAppData = [];
			}
		});
	}

	processResponseData(responseData: any): void {
		let appNameCnt = 0;
		// tslint:disable-next-line: prefer-for-of
		for (let i = 0; i < responseData.length; i++) {
			let clickRate;
			appNameCnt++;

			clickRate = responseData[i].click_rate;
			if (clickRate != null) {
				if (parseFloat(clickRate).toFixed(2) === '100.00') {
					clickRate = '100';
				} else {
					clickRate = parseFloat(clickRate).toFixed(2);
				}
			} else {
				clickRate = 0;
			}

			const formattedAppName = 'App ' + appNameCnt;

			const obj = {
				appName: responseData[i].appname,
				appNameCounter: appNameCnt,
				clickRate,
				clicks: responseData[i].clicks ? parseInt(responseData[i].clicks, 10) : '-',
				formattedAppName,
				formattedClickRate: clickRate ? clickRate + '%' : '-',
				formattedClicks: responseData[i].clicks ? numeral(responseData[i].clicks).format('0,0') : '-',
				formattedImpressions: responseData[i].impressions ? numeral(responseData[i].impressions).format('0,0') : '-',
				impressions: responseData[i].impressions ? parseInt(responseData[i].impressions, 10) : '-'
			};
			this.geofenceAppData.push(obj);
		}
	}

	impressionsComparator(a: any, b: any, c: any, d: any): number {
		if (c.impressions < d.impressions) {
			return 1;
		}
		if (c.impressions > d.impressions) {
			return -1;
		}
	}

	clicksComparator(a: any, b: any, c: any, d: any): number {
		if (c.clicks < d.clicks) {
			return 1;
		}
		if (c.clicks > d.clicks) {
			return -1;
		}
	}

	clickRateComparator(a: any, b: any, c: any, d: any): number {
		if (parseFloat(c.clickRate) < parseFloat(d.clickRate)) {
			return 1;
		}
		if (parseFloat(c.clickRate) > parseFloat(d.clickRate)) {
			return -1;
		}
	}

	appNameCounterComparator(a: any, b: any, c: any, d: any): number {
		if (c.appNameCounter < d.appNameCounter) {
			return 1;
		}
		if (c.appNameCounter > d.appNameCounter) {
			return -1;
		}
	}

	// downloadDataInCSV(event: any) {
	// 	event.preventDefault();
	// 	this.analyticsService.downloadCSV(this.key, this.datatableconfig.downloadFileName);
	// }
	downloadDataInCSV(event: any): void {
		event.preventDefault();
		this.analyticsService.downloadCSV(this.downloadConfiguration.csvQueryKey, this.downloadConfiguration.fileName);
	}

	onPageChange(event: any): void {
		this.currentPage = event.offset;
	}
}
